import { createFileRoute } from '@tanstack/react-router';

import { DisciplineCreate } from '@/module/Discipline/DisciplineCreate';

export const Route = createFileRoute('/_auth/administration/_administration/discipline/_discipline/create')({
  component: RouteComponent,
});

function RouteComponent() {
  return <DisciplineCreate />;
}
